import {Outlet as OutletMain, useLocation} from "react-router-dom";
import AppHeaderMain from "../app-header-main/app-header-main";
import FooterMain from "../footer-main/footer-main";
import ScrollToTop from "../sroll-to-top/sroll-to-top";
import styles from './layout-main.module.css'
import { useActiveButtonCountryTagChoice } from "../../services/context/CountryFilterContext"
import PopUpSection from "../pop-up-for-filtres/PopUpSection"
import PopUpForExitSection from "../pop-up-for-exit/PopUpForExitSection";
import PopUpCookie from "../pop-up-cookie/PopUpCookie";



function LayoutMain() {
const location = useLocation()
    const value = useActiveButtonCountryTagChoice()
    const PopUpSectionToggle = () => {
        if (((localStorage.getItem("country_tag") === null) || (localStorage.getItem("country_tag") === "undefined")) && (location.pathname === "/analytics-and-news/" || location.pathname === "/analytics-and-news")) {value.toggleVisible(true)} 
    }

    return (
        <>

        {PopUpSectionToggle()}
        {value.visible && <PopUpSection/>}
        {value.popUpExitVision && <PopUpForExitSection/>}
        {(value.popUpCookieVision && (localStorage.getItem("cookie") === null)) && <PopUpCookie/>}
      
    
        <div className={styles.page}>
            <ScrollToTop>
                <AppHeaderMain />

                <main className={styles.outlet}>
                    <OutletMain />
                </main>


                <FooterMain />
            </ScrollToTop>
        </div>
        </>
    )
}

export default LayoutMain